import { createFileRoute } from '@tanstack/react-router';
import { BenefitDetailPage } from './BenefitDetailPage';

export const Route = createFileRoute('/_protected/admin/benefits/$benefitId/')({
  component: BenefitDetailPage,
});
